module.exports = __webpack_public_path__ + "img/bnodata-white.ea650698.png";